export default __webpack_public_path__ + "static/media/mjcollege.f4083a47.png";